module.exports = __webpack_public_path__ + "img/cd-icon.6dfea3ac.svg";